export default class ServiceEvent {
  id: string
  roomId = ''
  serviceId = ''
  serviceName = ''
  staffId = ''
  status = ''
  createdAt: Date = new Date(0)
  confirmedAt = new Date(0)
  checkInAt: Date = new Date(0)
  closedAt = new Date(0)
  note = ''
  constructor (id: string) {
    this.id = id
  }
}
